import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ModuleService } from 'tnx-admin-service/authorization/module/services';
import { PermissionService } from 'tnx-admin-service/authorization/permission/services';
import { ColumnSchemaBase, ComponentContextService, CrudListComponent, DataListBase, DropdownControlSchema, EventData, GridInfo, ModelSchema, Operator, TreeDataOption } from 'tnx-shared';
@Component({
    selector: 'permission',
    templateUrl: './permission.component.html',
    styleUrls: ['./permission.component.scss'],
    providers: [ComponentContextService],
})
export class PermissionComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};


    treeData: any[];
    selectedTreeNode: any;
    phanHeControl: any;

    moduleCode: any;
    loaiQuyens: any = [];

    constructor(
        protected _injector: Injector,
        protected _permissionService: PermissionService,
        private _moduleService: ModuleService
    ) {
        super(_injector);
        this.customGetData = true;
    }

    ngOnInit() {
        this.setting.baseService = this._permissionService;
        this.setting.objectName = 'nhóm quyền';
        this.plusUrl = 'GetByPermission';

        this.setting.popupSize.height = 700;
        this.setting.popupSize.width = 1000;
        this.setting.popupSize.maximize = true;

        this.phanHeControl = new DropdownControlSchema({
            // field: 'moduleCode',
            placeholder: 'Chọn phân hệ',
            baseService: this._moduleService,
            displayField: 'name',
            valueField: 'code',
            showClear: false,
            enableCaching: true,
            loadOnInit: true,
            callbackDataFinish: (evt: EventData) => {
                this.getPhanHeData(evt.data);
            }
        });

        this.setting.modelSchemas = [
            new ModelSchema({ field: 'name', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'moduleCode', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'idParent', dataType: 'int', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'idPath', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'type', dataType: 'int', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'orderNo', dataType: 'int', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'description', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'code', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'currentStateCode', name: '', fullName: '', description: '' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'name' }),
            new ColumnSchemaBase({ field: 'moduleCode' }),
            new ColumnSchemaBase({ field: 'idParent' }),
            new ColumnSchemaBase({ field: 'idPath' }),
            new ColumnSchemaBase({ field: 'type' }),
            new ColumnSchemaBase({ field: 'orderNo' }),
            new ColumnSchemaBase({ field: 'description' }),
            new ColumnSchemaBase({ field: 'code' }),
            new ColumnSchemaBase({ field: 'currentStateCode' })
        ];
        super.ngOnInit();
    }

    async getPhanHeData(dataSource) {
        this.moduleCode = dataSource[0].code;
        this.getTreeNhom(dataSource[0].code);
    }

    async getTreeNhom(moduleCode?) {
        moduleCode = moduleCode || this.moduleCode;

        const rsNhomData = await this._permissionService.getAll([this.newFilter('moduleCode', Operator.equal, moduleCode)]);
        if (rsNhomData.success) {
            const nhomData = rsNhomData.data;
            this.treeData = this._crudService.getTreeDataWithOrder(nhomData, 'idParent', 'orderNo', <TreeDataOption>{ displayField: 'name', shortDisplayField: 'name' }, null);

            this.appendKeyToTreeNode(this.treeData);
        }
    }

    getDataCustom(gridInfo?: GridInfo) {
        this.getTreeNhom();
    }

    async modifyGridInfo(gridInfo) {
        if (this.selectedTreeNode && this.selectedTreeNode.data.id > 0) {
            gridInfo.filters.splice(0, 0, this.newFilter('idPermission', Operator.equal, this.selectedTreeNode.data.id));
        }
    }

    getPrefix(data) {
    }

    async beforeAdd() {
    }

    async modifyEditModel(data) {
        data.moduleCode = this.moduleCode;
    }

    appendKeyToTreeNode(treeNodes, parentKey?) {
        treeNodes.forEach((node, i) => {
            node.key = parentKey != null ? `${parentKey}_${i}` : `${i}`;
            if (node.children && node.children.length) {
                this.appendKeyToTreeNode(node.children, node.key);
            }
        });
    }

    handleNodeSelect() {
        if (this.selectedTreeNode) {
            // this.dataModel.readyToGetData = true;
            this._triggerProcessData();
        }
    }

    addChucNang() {
        // this.dataModel.nhomModel.data = {
        //     id: undefined,
        //     moduleCode: this.dataModel.moduleCode
        // };
        // this.dataModel.nhomModel.showEditForm = true;
    }

    editNhom(rowData, event) {
        // this.dataModel.nhomModel.data = {
        //     id: rowData.id,
        // };
        // this.dataModel.nhomModel.showEditForm = true;
    }

    deleteNhom(rowData, event) {
        this.executeDeleteNhom(rowData.id);
    }

    executeDeleteNhom(id) {
        this._notifierService.showDeleteConfirm('Bạn có chắc chắn muốn xóa? Xác nhận xóa sẽ xóa toàn bộ chuẩn đầu ra trong nhóm hiện tại!')
            .then(rs => {
                if (!rs) { return; }
                this._permissionService.delete(id)
                    .then(response => {
                        this.getTreeNhom();
                        this._triggerProcessData();
                        this._notifierService.showDeleteDataSuccess();
                    }, error => {
                        this._notifierService.showDeleteDataError();
                    });
            });
    }

    handleChangePhanHe(event) {
        this.getTreeNhom();
    }
}

